<template>
  <div>
    <el-card :class="'container'"
             shadow="hover">
      <div class="cart--item">
        <span class="cart--item--name"
              data-test="item--name">{{ product.name }}</span>
        <el-divider class="el-dividier"></el-divider>
        <span class="cart--item--unit"
              data-test="item--unit">{{ product.uc }}</span>
        <el-divider class="el-dividier"></el-divider>
        <div class="cart--item--quantity">
          <el-input-number v-if="isCart"
                           v-model="product.quantity"
                           @change="change_quantity_number(product, product.quantity)"
                           :min="1"
                           :max="999"
                           size="small"></el-input-number>
          <el-button v-if="isCart"
                     data-test="item--button"
                     class="cart--item--button"
                     type="danger"
                     icon="el-icon-delete"
                     circle
                     @click="$emit('deleteOneProduct', product)">
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    props: {
      product: undefined,
      isCart: Boolean,
    },
    computed: {

    },
    methods: {
      change_quantity_number(product, quantityAdded) {
        const payload = {
          quantityAdded,
          product,
        };
        this.$store.dispatch('cart/addGivenQuantityOfAProduct', payload);
      },
    },
  };
</script>

<style lang="stylus">
  .cart--item
    display flex
    flex-direction row
    align-content center
    align-items center

  .cart--item--name
    padding-right 20px
    margin-right 10px
    color $dark-color

  .cart--item--name, .cart--item--unit
    word-wrap: break-word
    width 10%
    flex-grow 2
    border-right #2c3e50 1px solid
    text-overflow ellipsis

  .cart--item--quantity
    display flex
    flex-direction row
    align-items center
    justify-content space-evenly
    flex-grow 1

  .el-dividier
    display none

  @media screen and (max-width: 900px)
    .cart--item
      width 100%
      display flex
      flex-direction column

    .cart--item--name, .cart--item--unit
      width 100%
      border none

    .el-dividier
      display inline

</style>
